module.exports = __webpack_public_path__ + "img/contact-form-1.60c7b917.png";